<template>
    <div class="sidebar-menu" data-scrollbar>
        <div class="sidebar-menu-inner">
            <app-left-panel-header></app-left-panel-header>
            <app-left-panel-profile></app-left-panel-profile>
            <app-left-panel-profile-active></app-left-panel-profile-active>
            <app-left-panel-courses></app-left-panel-courses>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import LeftPanelHeader from "../../chats/components/LeftPanelHeader";
    import LeftPanelProfile from "../../common_components/LeftPanelProfile";
    import LeftPanelProfileActive from '../../common_components/LeftPanelProfileActive';
    import LeftPanelCourses from './LeftPanelCourses'

    export default {
        data: () => ({

        }),
        methods: {},
        computed: {
            ...mapGetters([]),
        },
        components: {
            appLeftPanelHeader: LeftPanelHeader,
            appLeftPanelProfile: LeftPanelProfile,
            appLeftPanelProfileActive: LeftPanelProfileActive,
            appLeftPanelCourses: LeftPanelCourses
        },
    }
</script>

